import { render, staticRenderFns } from "./ProductButtonFavorite.vue?vue&type=template&id=59ce7956&scoped=true&"
import script from "./ProductButtonFavorite.vue?vue&type=script&lang=js&"
export * from "./ProductButtonFavorite.vue?vue&type=script&lang=js&"
import style0 from "./ProductButtonFavorite.vue?vue&type=style&index=0&id=59ce7956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce7956",
  null
  
)

export default component.exports